import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background:
    radial-gradient(circle at 15% 25%, rgba(245, 138, 138, 0.45) 0%, transparent 50%),
    radial-gradient(circle at 85% 75%, rgba(91, 91, 255, 0.55) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(166, 108, 217, 0.35) 0%, transparent 60%),
    linear-gradient(135deg, #1f1f5c 0%, #4a2e6b 50%, #5c3340 100%);
  color: ${CSSVars.white};
  padding: 80px 20px;
  position: relative;
  overflow: hidden;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 100px 30px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 120px 40px;
  }

  .inner {
    max-width: 820px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 1;
  }

  .eyebrow {
    display: inline-block;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(8px);
    color: #c2cfff;
    font-family: ${CSSVars.primaryFont};
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding: 6px 14px;
    border-radius: 999px;
    margin-bottom: 18px;
    border: 1px solid rgba(255, 255, 255, 0.15);
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 32px;
    line-height: 1.1;
    letter-spacing: -0.02em;
    color: ${CSSVars.white};
    margin: 0 0 16px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 44px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 56px;
    }
  }

  .subheadline {
    font-family: ${CSSVars.secondaryFont};
    font-size: 17px;
    line-height: 1.6;
    color: #c2cfff;
    margin: 0 auto 32px;
    max-width: 640px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 19px;
    }
  }

  .cta {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 17px;
    color: ${CSSVars.white};
    text-decoration: none;
    padding: 18px 40px;
    border-radius: 999px;
    background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.purple500} 50%, ${CSSVars.blue500} 100%);
    background-size: 200% 100%;
    background-position: 100% 0;
    transition: background-position 0.4s ease, transform 0.2s ease,
      box-shadow 0.2s ease;
    box-shadow: 0 12px 36px rgba(91, 91, 255, 0.5);

    &:hover {
      background-position: 0 0;
      transform: translateY(-2px);
      box-shadow: 0 16px 44px rgba(245, 138, 138, 0.55);
    }

    span {
      transition: transform 0.2s ease;
    }
    &:hover span {
      transform: translateX(3px);
    }

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 18px;
      padding: 20px 44px;
    }
  }

  .microcopy {
    font-family: ${CSSVars.secondaryFont};
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    margin: 20px 0 0;
  }
`;
